import {
  UPDATE_FOCUSED_PRODUCT_TILE,
  RESET_FOCUSED_PRODUCT_TILE,
  UPDATE_PRODUCTS,
  UPDATE_SEO_CONF,
} from './mutations'

export const ACTION_UPDATE_FOCUSED_PRODUCT_TILE = 'ACTION_UPDATE_FOCUSED_PRODUCT_TILE'
export const ACTION_RESET_FOCUSED_PRODUCT_TILE = 'ACTION_RESET_FOCUSED_PRODUCT_TILE'
export const ACTION_UPDATE_PRODUCTS = 'ACTION_UPDATE_PRODUCTS'
export const ACTION_UPDATE_SEO_CONF = 'ACTION_UPDATE_SEO_CONF'
export const actions = {
  [ACTION_RESET_FOCUSED_PRODUCT_TILE]: function ({ commit }) {
    commit(RESET_FOCUSED_PRODUCT_TILE)
  },
  [ACTION_UPDATE_FOCUSED_PRODUCT_TILE]: function ({ commit }, payload) {
    commit(UPDATE_FOCUSED_PRODUCT_TILE, payload)
  },
  [ACTION_UPDATE_PRODUCTS]: function ({ commit }, payload) {
    commit(UPDATE_PRODUCTS, payload)
  },
  [ACTION_UPDATE_SEO_CONF]: ({ commit }, payload) => {
    commit(UPDATE_SEO_CONF, payload)
  },
}
